/* eslint-disable no-console */
import DynamicModal from 'components/DynamicModal';
import IconButton from 'components/IconButton';
import { useAtomValue, useSetAtom } from 'jotai';
import callApi from 'lib/callApi';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import {
  Button,
  Table,
  Input,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from 'reactstrap';
import { companyIdAtom } from 'views/state';

import EPDetailModal from './EPDetailModal';
import {
  epListingDataAtom,
  forceRerenderUIAtom,
  selectedEnpointsFilterAtom,
} from './state';
import history from '../../../../../history';
import { getDrillDownUrl, getItemFromLocalStorage } from '../../helper';
import { epRefreshAtom } from '../state';

const _BASE_URL: string = getItemFromLocalStorage('approle') || '';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RowActions = ({ rowData, onLoading }) => {
  const companyId = useAtomValue(companyIdAtom);
  const selectedEndpointsFilter = useAtomValue(selectedEnpointsFilterAtom);

  const epListingData = useAtomValue(epListingDataAtom);
  const [detailModal, setDetailModal] = useState({
    isOpen: false,
    epId: 0,
    deletedBy: '',
    deletedDate: '',
  });
  const [openAliasModal, setOpenAliasModal] = useState(false);
  const [alias, setalias] = useState('');
  const [aliasId, setaliasId] = useState(0);

  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const forceReloadEPListing = useSetAtom(epRefreshAtom);
  const forceRerenderUI = useSetAtom(forceRerenderUIAtom);
  const [scanConfirmModalOpen, setScanConfirmModalOpen] = useState(false);
  const [scanCancelConfirmModalOpen, setScanCancelConfirmModalOpen] =
    useState(false);
  const [disableScanButton, setDisableScanButton] = useState(false);
  const [scanRequestInProgress, setscanRequestInProgress] = useState(
    rowData['scan_in_progress'],
  );

  useEffect(() => {
    if (rowData['scan_in_progress'] !== scanRequestInProgress) {
      setscanRequestInProgress(rowData['scan_in_progress']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData['scan_in_progress']]);

  async function confirmAliasModal() {
    setOpenAliasModal(false);
    const url = `endpoints/${aliasId}/`;
    await callApi(
      url,
      'PATCH',
      {},
      { alias: alias.trim(), company_id: companyId },
    )
      .then((res) => {
        if (res.status === 200) {
          if (res.data) {
            rowData['alias'] = alias.trim();
            forceRerenderUI(Math.random().toString());
            showSuccessToast('Alias Updated successfully.');
          }
        } else {
          console.error({
            function: 'confirmAliasModal',
            error: `Unexpected response: ${res.status}`,
            res,
          });
        }
      })
      .catch((err) => {
        const res = err.response;
        let error = 'Unknown error occurred. Please try again.';
        if (res && res.data) {
          if (res.data.detail.includes('duplicate')) {
            error =
              'An alias with same name is already assigned to another Endpoint. Please choose a different alias name.';
          } else {
            error = res.data.detail;
          }
          showFailureToast(error);
        }
      });
  }

  const handleEPDelete = async (id) => {
    setIsDeleting(true);
    await callApi(
      `endpoints/${id}/delete/`,
      'PATCH',
      {},
      { deleted: true, company_id: companyId },
    )
      .then((res) => {
        if (res.status === 200) {
          // update the listing data and counts
          const updatedcaListingData = epListingData.items.filter(
            (x) => x.id !== id,
          );
          epListingData.items = updatedcaListingData;
          epListingData.count = updatedcaListingData.length;
          showSuccessToast('Endpoint deleted successfully.');
        } else {
          console.error({
            function: 'handleDeleteEP',
            error: `Unexpected response: ${res.status}`,
            res,
          });
        }
      })
      .catch((err) => {
        const res = err.response;
        let error = 'Unknown error occured. Please try again.';
        if (res && res.data) {
          error = res.data.detail;
          showFailureToast(error);
        }
      })
      .finally(() => {
        setIsDeleting(false);
        setOpenConfirmDeleteModal(false);
        closeDetailModal();
        forceReloadEPListing(Math.random().toString());
      });
  };
  const closeDetailModal = () => {
    setDetailModal({ ...detailModal, isOpen: false });
  };

  const renderDeleteConfirmModal = () => {
    return (
      <Modal isOpen={openConfirmDeleteModal} size="sm">
        <ModalHeader>
          <h4>Delete Confirmation</h4>
        </ModalHeader>
        <ModalBody>
          <p>Are you sure you want to delete this Endpoint?</p>

          <label style={{ color: 'dodgerblue' }}>
            Note: This operation is <strong>irreversible</strong>. It will
            remove all vulnerabilities and related data of this Endpoint.
          </label>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setOpenConfirmDeleteModal(false)}
          >
            Cancel
          </Button>
          {isDeleting ? (
            <CircleSpinner size={20} color="#0665a9" loading={true} />
          ) : (
            <Button
              color="danger"
              disabled={isDeleting}
              onClick={() => handleEPDelete(detailModal.epId)}
            >
              Delete
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  };

  const renderDetailModal = () => {
    return (
      <Modal isOpen={detailModal.isOpen} toggle={closeDetailModal} size="lg">
        <ModalHeader toggle={closeDetailModal}>
          <h4>Endpoint Details</h4>
        </ModalHeader>
        <ModalBody>
          {detailModal.epId > 0 && <EPDetailModal id={detailModal.epId} />}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeDetailModal()}>
            Cancel
          </Button>
          {selectedEndpointsFilter !== 'deleted' ? (
            atob(localStorage.getItem(btoa('approle')) || btoa('client')) ===
              'admin' && (
              <Button
                color="danger"
                onClick={() => setOpenConfirmDeleteModal(true)}
              >
                Delete
              </Button>
            )
          ) : (
            <p>
              <strong>
                This endpoint is deleted by {detailModal.deletedBy} at{' '}
                {moment(detailModal.deletedDate).format('lll')}
              </strong>
            </p>
          )}
        </ModalFooter>
      </Modal>
    );
  };

  const openDetailModal = (epId, deletedBy, deletedDate) => {
    setDetailModal({
      isOpen: true,
      epId: epId,
      deletedBy: deletedBy,
      deletedDate: deletedDate,
    });
  };

  const renderCancelScanConfirmModal = () => {
    return (
      <DynamicModal
        isOpen={scanCancelConfirmModalOpen}
        toggle={() => setScanCancelConfirmModalOpen(false)}
        title={`Cancel Manual Scan`}
        content={
          <div>
            <p>Are you sure you want to cancel this scan?</p>
          </div>
        }
        size="sm"
        footerActions={
          <>
            <Button
              color="secondary"
              onClick={() => setScanCancelConfirmModalOpen(false)}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={() => {
                setScanCancelConfirmModalOpen(false);
                void handleCancelManualScan();
              }}
            >
              Confirm
            </Button>
          </>
        }
      />
    );
  };

  const handleCancelManualScan = async () => {
    const data = {
      company_id: companyId,
    };
    callApi(`endpoints/cancel_manual_scan/${rowData?.id}/`, 'PATCH', {}, data)
      .then((res) => {
        if (res.status === 200) {
          setDisableScanButton(false);
          setscanRequestInProgress(false);
          showSuccessToast('Manual scan cancelled successfully.');
        }
      })
      .catch((_err) => {
        showFailureToast(
          `Failed to cancel manual scan. SP360 is notified about the issue.`,
        );
      })
      .finally(() => {
        forceRerenderUI(Math.random().toString());
      });
  };

  const renderScanConfirmModal = () => {
    return (
      <DynamicModal
        isOpen={scanConfirmModalOpen}
        toggle={() => setScanConfirmModalOpen(false)}
        title={`Confirm Manual Scan`}
        content={
          <div>
            <p>
              Are you sure you want to proceed with manual scan for this
              Endpoint?
            </p>
          </div>
        }
        size="sm"
        footerActions={
          <>
            <Button
              color="secondary"
              onClick={() => setScanConfirmModalOpen(false)}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={() => {
                setScanConfirmModalOpen(false);
                setscanRequestInProgress(true);
                setDisableScanButton(true);
                void handleManualScan(id);
              }}
            >
              Confirm
            </Button>
          </>
        }
      />
    );
  };

  const handleManualScan = async (endpoint_id) => {
    console.log('manual scan', endpoint_id);
    const data = {
      company_id: companyId,
    };

    callApi(`endpoints/manual_scan/${rowData?.id}/`, 'PATCH', {}, data)
      .then((res) => {
        if (res.status === 201) {
          showSuccessToast('Manual scan initiated successfully.');
        } else {
          setscanRequestInProgress(false);
          console.error({
            function: 'handleManualScan',
            error: `Unexpected response: ${res.status}`,
            res,
          });
          showFailureToast(
            `Failed to launch manual scan. SP360 is notified about the issue.`,
          );
        }
      })
      .catch((err) => {
        console.error('Failed to launch manual scan:', err);
        if (err?.status === 405) {
          showFailureToast(
            `Failed to launch manual scan. SP360 is notified about the issue.`,
          );
        } else {
          showFailureToast(
            `Failed to launch manual scan. SP360 is notified about the issue.`,
          );
        }
        setscanRequestInProgress(false);
      })
      .finally(() => {
        setDisableScanButton(false);
        forceRerenderUI(Math.random().toString());
      });
  };

  const manualScanSpinner = (
    <CircleSpinner size={20} color="#0665a9" loading={true} />
  );

  const id: number = rowData['id'];
  const deleted: boolean = selectedEndpointsFilter === 'deleted';
  const deletedBy = rowData['deleted_endpoint__deleted_by'];
  const deletedDate = rowData['deleted_endpoint__deleted_on'];

  return (
    <div className="text-nowrap">
      {/* Only show for active EP*/}
      {!deleted && (
        <>
          <IconButton
            id="editAlias"
            iconClass="fa fa-edit"
            size="sm"
            tooltip="Edit Alias"
            onClick={() => {
              setOpenAliasModal(true);
              setalias(rowData['alias']);
              setaliasId(rowData['id']);
            }}
          />
          {scanRequestInProgress ? (
            <IconButton
              id="scansLink"
              size="sm"
              tooltip="Scan is in progress, click to cancel"
              onClick={() => {
                setScanCancelConfirmModalOpen(true);
              }}
              iconElement={manualScanSpinner}
            />
          ) : (
            <IconButton
              id="manualScanLink"
              iconClass="fa fa-search"
              size="sm"
              tooltip="Click to initiate scan"
              onClick={() => {
                setScanConfirmModalOpen(true);
              }}
              disabled={disableScanButton}
            />
          )}
          <IconButton
            id="vulnLink"
            iconClass="fa fa-bug"
            size="sm"
            tooltip="View Vulnerabilities"
            onClick={() =>
              history.push(
                getDrillDownUrl({
                  type: 'open',
                  sourceType: 'endpoint_data',
                  hosts_in: [rowData.id],
                  severity: '',
                  issueType: '',
                  qid: '',
                  severity_in: undefined,
                }),
                // `/${BASE_URL}/qualys/vulnerabilities?source_type=endpoint_data&endpoint_id=${id}`,
              )
            }
          />
        </>
      )}
      <IconButton
        id="detailsLink"
        iconClass="fa fa-eye"
        size="sm"
        tooltip="View Endpoint Details"
        onClick={() => openDetailModal(id, deletedBy, deletedDate)}
      />
      {/* NOTE: Always conditionally render modal dialogs for performance */}
      {detailModal.isOpen && renderDetailModal()}
      {openConfirmDeleteModal && renderDeleteConfirmModal()}
      {scanConfirmModalOpen && renderScanConfirmModal()}
      {scanCancelConfirmModalOpen && renderCancelScanConfirmModal()}
      {openAliasModal && (
        <Modal isOpen={openAliasModal} size="lg">
          <ModalHeader>Edit Endpoint Alias</ModalHeader>
          <ModalBody>
            <Table className="tablesorter table-striped" responsive>
              <tbody>
                <tr>
                  <td>Alias</td>
                  <td>
                    <Input
                      type="text"
                      value={alias}
                      placeholder="Alias (Max length 255 characters)"
                      maxLength={255}
                      onChange={(e) => {
                        setalias(e.target.value);
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setOpenAliasModal(false)}>
              Cancel
            </Button>
            <Button color="primary" onClick={() => confirmAliasModal()}>
              Save
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
};

export default RowActions;
